import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, BadgeCheck, Trophy, TrendingUp, Flame, Crown } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import AppNav from "@/components/AppNav";

const TABS = [
  { id: "top_earnings", label: "Top guadagni", icon: Trophy },
  { id: "emerging", label: "Emergenti", icon: TrendingUp },
  { id: "popular", label: "Più popolari", icon: Flame },
];

const RANK_STYLES = ["text-[#F5C6D6]", "text-white/80", "text-[#E91E8C]"];

export default function Leaderboard() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("top_earnings");

  useEffect(() => {
    api.get("/leaderboard").then(({ data }) => setData(data)).catch(() => setData({ top_earnings: [], emerging: [], popular: [] }));
  }, []);

  const rows = data ? data[tab] || [] : null;

  return (
    <div className="flex bg-[#0D0D0D] min-h-screen text-white">
      <AppNav />
      <main className="flex-1 p-5 sm:p-8 pb-24 md:pb-8 overflow-x-hidden">
        <div className="max-w-2xl">
          <h1 className="text-3xl font-black font-heading mb-1 flex items-center gap-2">
            <Trophy className="w-7 h-7 text-[#F5C6D6]" /> Classifica
          </h1>
          <p className="text-white/50 mb-6 text-sm">I creator che stanno spaccando su Luvme.</p>

          {/* Tabs */}
          <div className="flex gap-2 mb-6 overflow-x-auto no-scrollbar -mx-5 sm:-mx-8 px-5 sm:px-8">
            {TABS.map((t) => (
              <button
                key={t.id} onClick={() => setTab(t.id)} data-testid={`leaderboard-tab-${t.id}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap border transition-colors ${
                  tab === t.id ? "bg-[#E91E8C] border-[#E91E8C] text-white" : "bg-transparent border-white/15 text-white/70 hover:border-[#E91E8C]/50 hover:text-white"
                }`}
              >
                <t.icon className="w-3.5 h-3.5" /> {t.label}
              </button>
            ))}
          </div>

          {rows === null ? (
            <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-[#E91E8C] animate-spin" /></div>
          ) : rows.length === 0 ? (
            <div className="text-center py-16 text-white/50 bg-[#1A1A1A] border border-white/10 rounded-3xl" data-testid="leaderboard-empty">
              Nessun dato ancora in questa classifica.
            </div>
          ) : (
            <div className="space-y-2.5" data-testid="leaderboard-list">
              {rows.map((c, i) => (
                <Link
                  key={c.creator_id} to={`/creator/${c.creator_id}`} data-testid={`leaderboard-row-${c.creator_id}`}
                  className="flex items-center gap-4 bg-[#1A1A1A] border border-white/10 rounded-2xl px-4 py-3 card-hover-glow"
                >
                  <span className={`w-7 text-center text-lg font-black font-heading ${i < 3 ? RANK_STYLES[i] : "text-white/40"}`}>{i + 1}</span>
                  <div className="relative">
                    <img src={mediaUrl(c.avatar_url)} alt={c.display_name} className="w-11 h-11 rounded-full object-cover border border-white/10" />
                    {i === 0 && <Crown className="absolute -top-2 -right-1 w-4 h-4 text-[#F5C6D6]" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5">
                      <span className="font-semibold text-sm truncate">{c.display_name}</span>
                      {c.is_verified && <BadgeCheck className="w-3.5 h-3.5 text-[#F5C6D6] shrink-0" />}
                    </div>
                    <p className="text-xs text-white/40">{tab === "emerging" ? "In crescita" : tab === "popular" ? "Community" : "Guadagni"}</p>
                  </div>
                  <span className="text-sm font-bold text-[#E91E8C] shrink-0">{c.metric}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
